const metaTag = document.querySelector('meta[name="tax-rate"]');
const TAX_RATE = metaTag ? parseFloat(metaTag.content) : 0.1;

/**
 * 端数処理（変更容易にするためメソッド化）
 */
function roundTax(value) {
    return Math.round(value);
}

export function getTaxRate() {
    return TAX_RATE;
}

export function calcTax(price) {
    return roundTax(price * TAX_RATE);
}

export function calcTaxIncluded(price) {
    return roundTax(price * (1 + TAX_RATE));
}

export function calcPriceFromTaxIncluded(taxIncludedPrice) {
    return roundTax(taxIncludedPrice / (1 + TAX_RATE));
}

export function calcTaxFromTaxIncluded(taxIncludedPrice) {
    return taxIncludedPrice - calcPriceFromTaxIncluded(taxIncludedPrice);
}
